export const redirectTo = (url) => () => { window.top.location.href = url }
